// TODO: Move to containers
import { debounce, get, size, each } from 'lodash';

export const Carousel = {
  transclude: true,

  bindings: {
    list: '<',
    settings: '<',
    isLoading: '<',
  },

  template: `
    <div class="carousel-vm">
      <h4 class="carousel-loading py-3" ng-show="$ctrl.isLoading">
        <spinner is-loading="true">
          Loading
        </spinner>
      </h4>
      <div class="carousel-container" ng-hide="$ctrl.isLoading">
        <div class="carousel-track-wrapper">
          <div class="carousel-track" ng-transclude></div>
        </div>
        <div class="carousel-controls"
          ng-show="$ctrl.listSize > $ctrl.slidesShowing">
          <button class="carousel-prev"
            type="button"
            ng-click="$ctrl.prev()">
            <i class="fa fa-chevron-left"></i>
          </button>
          <button class="carousel-next"
            type="button"
            ng-click="$ctrl.next()">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>`,

  controller($element, $timeout, $window) {
    'ngInject';

    // Private methods
    const track = () => {
      return $element.find('.carousel-track');
    };

    const trackWrapper = () => {
      return $element.find('.carousel-track-wrapper');
    };

    const slides = () => {
      return track().children();
    };

    const selected = () => {
      return track()
        .find('.selected')
        .first();
    };

    let guid;

    return {
      $onInit() {
        this.position = 0;

        this.setOptions();
        this.setToShow();
        this.checkMode();
        this.setSelected();

        // Watch window resize
        guid = Math.round(Math.random() * 100000);

        const onResize = debounce(() => {
          $timeout(() => this.resize());
        }, 100);

        $($window).on(`resize.carousel${guid}`, onResize);
      },

      $onDestroy() {
        $($window).off(`resize.carousel${guid}`);
      },

      $onChanges(changes) {
        const list = get(changes, 'list.currentValue');

        this.listSize = size(list) || 0;

        if (this.listSize) {
          $timeout(() => {
            this.setDimensions();
            this.setSelected();
          });
        }
      },

      setOptions() {
        const defaults = {
          slidesToShow: 5,
          responsive: [
            { slidesToShow: 4, breakpoint: 1200 },
            { slidesToShow: 3, breakpoint: 992 },
          ],
        };

        this.options = {
          ...defaults,
          ...this.settings,
        };
      },

      setToShow() {
        let slidesShowing = this.options.slidesToShow;

        if (this.options.responsive) {
          each(this.options.responsive, data => {
            if (window.innerWidth < data.breakpoint) {
              slidesShowing = data.slidesToShow;
            }
          });
        }

        this.slidesShowing = slidesShowing;
      },

      setSelected() {
        if (selected().length) {
          let position = slides().index(selected().parent());

          if (position > this.listSize - this.slidesShowing) {
            position = this.listSize - this.slidesShowing;
          }

          this.setPosition(position, this.listSize);
        }
      },

      setDimensions() {
        let width = 0;
        let height = 0;

        slides().each((i, slide) => {
          width += $(slide).outerWidth();
          height = Math.max(height, $(slide).outerHeight());
        });

        width = Math.ceil(width);

        track().width(width);
        trackWrapper().height(height);
      },

      setPosition(position) {
        let offset = 0;

        slides().each((i, slide) => {
          if (i >= position) {
            return;
          }

          offset += $(slide).outerWidth();
        });

        track().animate(
          { xcoord: offset * -1 },
          {
            duration: 300,
            step(now, fx) {
              $(this).css({ transform: `translate3d(${now}px, 0, 0)` });
            },
          }
        );

        // Set scrollbar for scrolling mode
        if (this.mode === 'scroll') {
          trackWrapper().scrollLeft(offset);
        }

        this.position = position;
      },

      prev() {
        this.changeSlide(this.position - 1, this.listSize);
      },

      next() {
        this.changeSlide(this.position + 1, this.listSize);
      },

      changeSlide(next, size) {
        if (next > size - this.slidesShowing || next > size) {
          next = 0;
        } else if (next < 0) {
          next = size - this.slidesShowing || size - 1;
        }

        this.setPosition(next);
      },

      resize() {
        this.setDimensions();
        this.setPosition(this.position);
        this.checkMode();

        if (this.options.responsive) {
          this.setToShow();
        }
      },

      checkMode() {
        const mode =
          trackWrapper().css('overflow') === 'auto' ? 'scroll' : 'fixed';

        if (this.mode === mode) {
          return;
        }

        // Reset scroll left offset
        if (mode === 'fixed') {
          trackWrapper().scrollLeft(0);
        }

        this.mode = mode;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Carousel/Carousel.js